import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'
import { useState } from 'react'

interface TruncatedLabelProps {
	label: string
	className?: string
	side?: 'top' | 'right' | 'bottom' | 'left'
	/** Lands on the tooltip, so a test can assert the full text. */
	testId?: string
}

/** A label that, when its box is too narrow for it, shows in full on hover. */
export function TruncatedLabel({ label, className, side = 'right', testId }: TruncatedLabelProps) {
	// A tooltip per row slows a long list down, so one mounts only on a label hovered while truncated.
	const [truncated, setTruncated] = useState(false)
	const text = (
		<span
			className={cn('truncate', className)}
			onPointerEnter={event => setTruncated(event.currentTarget.scrollWidth > event.currentTarget.clientWidth)}>
			{label}
		</span>
	)
	if (!truncated) {
		return text
	}
	return (
		<Tooltip>
			<TooltipTrigger asChild focusable={false}>
				{text}
			</TooltipTrigger>
			<TooltipContent side={side} className='max-w-sm wrap-break-word' data-testid={testId}>
				{label}
			</TooltipContent>
		</Tooltip>
	)
}
